<template>  
  <div class="merchantctrl">   
    <el-select filterable :size="slsize" v-model="slvl" :multiple='isbc' clearable style="width: 100%;" :placeholder="$t('app_select')" @change="onChange">
      <el-option
        v-for="item in tableData"
        :key="item[vlkey]"
        :label="item.agentName"
        :value="item[vlkey]">
      </el-option>
    </el-select>
  </div>
  <!-- <span :style="setSpace(item.agentGrade)">{{ item.agentName }}</span>	 -->
  
</template>

<script>
export default {  
  data () {
    return { 
      tableData: [],
      slvl: '',
      slsize: 'small',
      vlkey: 'agentId',
      type:'',
      isbc: false
    }
  },
  // value size两个值，callback回调选择的值
  props: ['config'],
  watch: {
    config (n) {
      this.vlkey = n.vlkey?n.vlkey:this.vlkey 
      this.slsize = n.size
	    this.slvl = n.value?n.value:''
      this.type = n.type	  
      this.isbc = n.isbc?true:false
      this.getList()
      if (this.isbc && this.slvl) {
        var arr = []
        this.slvl.forEach(item => {
          arr.push(parseInt(item))
        });
        this.slvl = arr
      }
    }
  },
  methods: {
	setSpace (level) {
	  var val = parseInt(level)*20
	  return `margin-left: ${val}px;`
	},
    onChange (vl) {
      if (this.config.callback) {
        this.config.callback(vl)
      }
    },
    getList () { 
      if (this.type === '0'){ 
        this.$agentCtrlList(res => {
            if (res.status == 200) {                 
              this.tableData = res.data
              // alert(this.slvl + ' ' + this.vlkey + ' rfrs')
            }
          }, '')
      }else if (this.type === '1'){
         this.$agentWithDevList(res => {
            if (res.status == 200) {
              this.tableData = res.data
              // this.$set()
            }
          }, '')
      }
    
    }
  },
  mounted () {
    ///// init
    if (this.config) {
      this.slvl = this.config.value?this.config.value:''
      this.slsize = this.config.size
      this.vlkey = this.config.vlkey?this.config.vlkey:this.vlkey
      this.type = this.config.type
      this.isbc = this.config.isbc?true:false

      if (this.isbc && this.slvl) {
        var arr = []
        this.slvl.forEach(item => {
          arr.push(parseInt(item))
        });
        this.slvl = arr
      }
    }
    if (this.type == null) this.type = '0'
    this.getList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .merchantctrl {
    width: 100%;
  }
</style>
